import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import listPlugin from '@fullcalendar/list';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import Select from 'react-select';
import DatetimeRangePicker from 'react-datetime-range-picker';

import Services from '../../services/service';
import './Schedule.css';
import {MODALACTION, RESPONSE} from '../../config/constants';
import {isEmptyObject} from "jquery";
import ReactNotification, {store} from "react-notifications-component";
import moment from "moment";
const { CREATE, VIEW, EDIT } = MODALACTION;
const { SUCCESS, FAILED, ADDED, INVALID } = RESPONSE;

const slotLabelFormat = {
  "hour": "2-digit", //2-digit, numeric
  "minute": "2-digit", //2-digit, numeric
  "meridiem": false,
  "hour12": false
}

class ScheduleCalendar extends Component {
  constructor(props){
    super(props);

		this.state = {
      modalAdd: false,
      actionModal: '',
      type: '',
      scheduleList: [],
      divisionList: [],
      listSchedule: {},
      title: '',
      description: '',
      division: '',
      reminder: '',
			events: [],
      eventName: '',
      startDate: '',
      endDate: '',
      moduleName: '',
			headerToolbar: {
				left: 'dayGridMonth,timeGridWeek,timeGridDay',
				center: 'title',
				right: 'prev,next today'
			},
			buttonText: {
				today:    'Today',
				month:    'Month',
				week:     'Week',
				day:      'Day'
			}
		};
    this.initialState = this.state;
  };

  componentDidMount() {
    this.renderExternalEvents();
    this.getScheduleType();
    this.getPositionList();
    this.getScheduleList();
  }

  getScheduleType = () => {
    Services.getList({param: 'schedule-type'})
      .then(res => {
        this.setState({scheduleList: res});
      })
      .catch(err => console.log(err))
  };

  getScheduleList = () => {
    Services.getScheduleList()
      .then(res => {
        this.setState({listSchedule: res, events: res.calendar});
      })
      .catch(err => console.log(err))
  };

  getPositionList = () => {
    Services.getList({param: 'division'})
      .then(res => {
        this.setState({divisionList: res});
      })
      .catch(err => console.log(err))
  };

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Schedule Calendar</li>
      </ol>
      <h1 className="page-header">Calendar </h1>
    </div>
  );

  addNotification = (notificationType, notificationTitle, notificationMessage, notificationPosition) => {
    store.addNotification({
      title: notificationTitle,
      message: notificationMessage,
      type: notificationType,
      insert: "top",
      container: notificationPosition,
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 2000 },
      dismissable: { click: true }
    });
  }

  toggleNotification = action => {
    switch(action){
      case SUCCESS:
        this.addNotification('success', 'Success', 'Schedule submitted', 'top-right');
        break;
      case FAILED:
        this.addNotification('danger', 'Danger', 'Oops something went wrong !', 'top-right');
        break;
      case ADDED:
        this.addNotification('success', 'Success', 'New Schedule Added', 'top-right');
        break;
      case EDIT:
        this.addNotification('success', 'Success', 'Schedule Updated', 'top-right');
        break;
      case INVALID:
        this.addNotification('danger', 'Invalid Format', 'This field must be a number', 'top-right');
        break;
      default:
        break;
    }
  };

  handleFieldChange = (key) => (e) => {
    const re = /^[0-9\b]+$/;
    if(key === "reminder") {
      if (e.target.value === "" || re.test(e.target.value)) {
        const state = { [key]: e.target.value };
        this.setState(state);
      } else {
        this.toggleNotification(INVALID)
      }
    } else if(key === "division") {
      const state = { [key]: e.value };
      this.setState(state);
    } else if(key === "type") {
      const state = { [key]: e.target.value, eventName: document.getElementById(e.target.value).innerHTML };
      this.setState(state);
    } else {
      const state = { [key]: e.target.value };
      this.setState(state);
    }
  };

  renderAddSchedule = () => (
  	<div style={{marginBottom: '10px'}}>
			<button
				style={{padding: '7px'}}
				className="btn btn-sm btn-primary width-70"
				onClick={() => this.toggleAddModal(CREATE)}>Add</button>
		</div>
	);

  setHeaderItemText = (value) => {
    switch (value) {
      case CREATE :
        return 'Add Schedule';
      case VIEW :
        return 'View Schedule';
      default:
        return '';
    }
  };

  setActionButton = (value) => {
    if (value === CREATE) {
      this.handleSubmitData();
    }
  };

  handleSubmitData = () => {
    const { type, title, description, division, reminder, eventName, startDate, endDate } = this.state;
    if(eventName !== "Event") {
      const payload = {
        type, title, desc: description, role: division, reminder
      };
      Services.postSchedule(payload)
        .then(res => {
          this.setState(this.initialState);
          this.toggleNotification(SUCCESS);
          this.getScheduleType();
          this.getPositionList();
          this.getScheduleList();
        })
        .catch(err => {
          console.log(err);
          this.setState({ modalAdd: false });
          this.toggleNotification(FAILED);
        });
    }
    else {
      const payload = {
        type, title, desc: description, role: division, reminder, startDate, endDate, newStatus: 1
      };
      Services.postEventSchedule(payload)
        .then(res => {
          this.setState(this.initialState);
          this.toggleNotification(SUCCESS);
          this.getScheduleType();
          this.getPositionList();
          this.getScheduleList();
        })
        .catch(err => {
          console.log(err);
          this.setState({ modalAdd: false });
          this.toggleNotification(FAILED);
        });
    }
  };

  toggleAddModal = (action = '', item = {}) => {
    this.setState({
      modalAdd: !this.state.modalAdd,
      actionModal: action,
      selectedItem: item
    });
    if(action === '') {
      this.setState({
        type: '',
        title: '',
        description: '',
        division: '',
        reminder: '',
        startDate: '',
        endDate: '',
        eventName: '',
        moduleName: ''
      });
    }
  };

  formatGroupLabel = data => (
    <div>
      <span>{data.label}</span>
      <span>{data.options.length}</span>
    </div>
  );

  setDateRange = value => {
    this.setState({
      startDate: moment( value.start).format( 'MM-DD-YYYY HH:mm'),
      endDate: moment( value.end).format( 'MM-DD-YYYY HH:mm')
    });
  };

  renderAddScheduleModal = () => {
    const { actionModal, selectedItem, type, title, description, division, reminder, eventName, startDate, endDate, moduleName } = this.state;
    let formData = [];
    let disabled;
    if(eventName === 'Event'){
      formData = [type, title, description, division, reminder, startDate, endDate];
      disabled = formData.includes('') || formData.includes('Invalid date');
    } else {
      formData = [type, title, description, division, reminder];
      disabled = formData.includes('');
    }
    const textHeader = this.setHeaderItemText(actionModal);
    const filled = isEmptyObject(selectedItem);
    let scheduleOptions = this.state.scheduleList.length > 0
      && this.state.scheduleList.map((item, i) => {
        return (
          <option key={i} value={item.id} id={item.id}>{item.name}</option>
        )
      }, this);
    return (
      <Modal isOpen={this.state.modalAdd} toggle={() => this.toggleAddModal()}>
        <ModalHeader toggle={() => this.toggleAddModal()}>{textHeader}</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Tipe Schedule</label>
            <select
              onChange={this.handleFieldChange('type')}
              type="select" className="form-control"
              defaultValue={!filled ? selectedItem.type : type }
              disabled={actionModal === VIEW}
            >
              <option disabled value=''> - pilih - </option>
              {scheduleOptions}
            </select>
          </div>
          <div className="form-group">
            <label>Judul</label>
            <input
              onChange={this.handleFieldChange('title')}
              type="text" className="form-control"
              defaultValue={!filled ? selectedItem.title : title}
              disabled={actionModal === VIEW}
            />
          </div>
          <div className="form-group">
            <label>description</label>
            <textarea
              onChange={this.handleFieldChange('description')}
              type="text" className="form-control"
              defaultValue={!filled ? selectedItem.description : description}
              disabled={actionModal === VIEW}
            />
          </div>
          <div className="form-group">
            <label>Divisi</label>
            <Select
              defaultValue={ !filled ? selectedItem.division : division }
              onChange={this.handleFieldChange('division')}
              isDisabled={actionModal === VIEW}
              options={this.state.divisionList}
              formatGroupLabel={this.formatGroupLabel}
            />
          </div>
          {/* <div className="form-group">
            <label>Set Reminder</label>
            <div className="input-group mb-3">
              <input
                onChange={this.handleFieldChange('reminder')}
                type="text" className="form-control"
                defaultValue={!filled ? selectedItem.reminder : reminder }
                disabled={actionModal === VIEW}
              />
              <span className="input-group-text">days</span>
            </div>
          </div> */}
          <div className="form-group">
            <label>Form Checklist</label>
            <div className="input-group mb-3">
              <input
                onChange={this.handleFieldChange('moduleName')}
                type="text" className="form-control"
                defaultValue={!filled ? selectedItem.moduleName : moduleName }
                disabled={actionModal === VIEW}
              />
            </div>
          </div>
          {eventName === 'Event' &&
          <div className="form-group">
            <label>Set Date and Time</label>
            <div>
              <DatetimeRangePicker
                required
                startDate={''}
                endDate={''}
                onChange={this.setDateRange}
              />
            </div>
          </div>
          }
        </ModalBody>
        {actionModal === CREATE &&
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleAddModal()}>Cancel</button>
          <button
            className="btn btn-primary"
            disabled={actionModal === CREATE && disabled}
            onClick={() => this.setActionButton(actionModal)}
          >
            {actionModal}
          </button>
        </ModalFooter>
        }
      </Modal>
    )
  };

  renderListTahunan = () => {
    const { listSchedule } = this.state;
    let scheduleTahunan = listSchedule.list && listSchedule.list.length > 0
      && listSchedule.list.map((item, i) => {
        if(item.typeName === '1 Tahun') {
          return (
            <div>
              <div className="fc-event">
                <div className="fc-event-text">{item.title}</div>
              </div>
            </div>
          )
        }
      }, this);
    return (
      <div>
        <h5 className="mb-3">1 Tahun</h5>
        {scheduleTahunan}
      </div>
    )
  };

  renderListBulanan = () => {
    const { listSchedule } = this.state;
    let scheduleBulanan = listSchedule.list && listSchedule.list.length > 0
      && listSchedule.list.map((item, i) => {
        if(item.typeName === 'Bulanan') {
          return (
            <div>
              <div className="fc-event">
                <div className="fc-event-text" id={item.id}>{item.title}</div>
              </div>
            </div>
          )
        }
      }, this);
    return (
      <div>
        <h5 className="mb-3">Bulanan</h5>
        {scheduleBulanan}
      </div>
    )
  };

  renderListMingguan = () => {
    const { listSchedule } = this.state;
    let scheduleMingguan = listSchedule.list && listSchedule.list.length > 0
      && listSchedule.list.map((item, i) => {
        if(item.typeName === 'Mingguan') {
          return (
            <div>
              <div className="fc-event">
                <div className="fc-event-text" id={item.id}>{item.title}</div>
              </div>
            </div>
          )
        }
      }, this);
    return (
      <div>
        <h5 className="mb-3">Mingguan</h5>
        {scheduleMingguan}
      </div>
    )
  };

  renderListTriwulan = () => {
    const { listSchedule } = this.state;
    let scheduleTriwulan = listSchedule.list && listSchedule.list.length > 0
      && listSchedule.list.map((item, i) => {
        if(item.typeName === '3 BUlan') {
          return (
            <div>
              <div className="fc-event">
                <div className="fc-event-text" id={item.id}>{item.title}</div>
              </div>
            </div>
          )
        }
      }, this);
    return (
      <div>
        <h5 className="mb-3">3 Bulan</h5>
        {scheduleTriwulan}
      </div>
    )
  };

  renderListSemester = () => {
    const { listSchedule } = this.state;
    let scheduleSemester = listSchedule.list && listSchedule.list.length > 0
      && listSchedule.list.map((item, i) => {
        if(item.typeName === '6 Bulan') {
          return (
            <div>
              <div className="fc-event">
                <div className="fc-event-text" id={item.id}>{item.title}</div>
              </div>
            </div>
          )
        }
      }, this);
    return (
      <div>
        <h5 className="mb-3">6 Bulan</h5>
        {scheduleSemester}
      </div>
    )
  };

  renderListEvent = () => {
    const { listSchedule } = this.state;
    let scheduleEvent = listSchedule.list && listSchedule.list.length > 0
      && listSchedule.list.map((item, i) => {
        if(item.typeName === 'Event') {
          return (
            <div>
              <div className="fc-event">
                <div className="fc-event-text" id={item.id}>{item.title}</div>
              </div>
            </div>
          )
        }
      }, this);
    return (
      <div>
        <h5 className="mb-3">Event</h5>
        {scheduleEvent}
      </div>
    )
  };

  renderList = () => {
    return(
      <div id="external-events" className="fc-event-list">
        {/* {this.renderAddSchedule()}
        {this.renderListMingguan()}
        <hr className="bg-grey-lighter my-3"/>
        {this.renderListBulanan()}
        <hr className="bg-grey-lighter my-3"/>
        {this.renderListTriwulan()}
        <hr className="bg-grey-lighter my-3"/>
        {this.renderListSemester()}
        <hr className="bg-grey-lighter my-3"/>
        {this.renderListTahunan()}
        <hr className="bg-grey-lighter my-3"/>
        {this.renderListEvent()} */}
      </div>
    )
  };

  renderExternalEvents = () => {
    var containerEl = document.getElementById('external-events');
    new Draggable(containerEl, {
      itemSelector: '.fc-event',
      eventData: function(eventEl) {
        return {
          title: eventEl.innerText
        };
      }
    });
  };

  onDrop = async (info) => {
    const param = {params: { scheduleId: info.draggedEl.firstChild.id }};
    const { start, end } = info.event._instance.range;
    const payload = {
      startDate: moment(start, "DD-MM-YYYY hh:mm:ss").subtract(7, 'hours').format('YYYY-MM-DD HH:mm'),
      endDate: moment(end, "DD-MM-YYYY hh:mm:ss").subtract(7, 'hours').format('YYYY-MM-DD HH:mm'),
      newStatus: 1
    };
    Services.postChangeScheduleStatus(payload, param)
      .then(res => {
        this.toggleNotification(ADDED);
        window.location.reload();
      })
      .catch(err => {
        console.log(err);
        this.toggleNotification(FAILED);
      });
  };

  onChange = (info) => {
    const param = {params: { scheduleId: info.event._def.publicId }};
    const { start, end } = info.event._instance.range;
    const payload = {
      startDate: moment(start, "DD-MM-YYYY hh:mm:ss").subtract(7, 'hours').format('YYYY-MM-DD HH:mm'),
      endDate: moment(end, "DD-MM-YYYY hh:mm:ss").subtract(7, 'hours').format('YYYY-MM-DD HH:mm'),
      newStatus: 2
    };
    Services.postChangeScheduleStatus(payload, param)
      .then(res => {
        this.toggleNotification(EDIT);
      })
      .catch(err => {
        console.log(err);
        this.toggleNotification(FAILED);
      });
  };

  onClick = (info) => {
    const param = {params: { scheduleId: info.event._def.publicId }};
    
    Services.getDetailSchedule(param)
      .then(res => {
        this.toggleAddModal(VIEW, res)
      })
      .catch(err => {
        console.log(err);
        this.toggleNotification(FAILED);
      });
  };

  render(){
    return(
      <div>
        {this.renderBreadcrumb()}
        <ReactNotification/>
        {this.renderAddScheduleModal()}
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around",  }}>
          <div style={{width: "2%"}}>
            {this.renderList()}
          </div>
          <div style={{ width: "99%"}}>
            <FullCalendar
              plugins={[ dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin, bootstrapPlugin ]}
              initialView="dayGridMonth"
              themeSystem="bootstrap"
              headerToolbar={this.state.headerToolbar}
              buttonText={this.state.buttonText}
              events={this.state.events}
              eventReceive={info => this.onDrop(info)}
              eventChange={info => this.onChange(info)}
              eventClick={info => this.onClick(info)}
              slotLabelFormat={slotLabelFormat}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default ScheduleCalendar;
